/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Archival_Remove_PlayerInputs */



/**
* | output |
* | --- |
* | "Remove player" |
*
* @param {Archival_Remove_PlayerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const archival_remove_player = /** @type {((inputs?: Archival_Remove_PlayerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Archival_Remove_PlayerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retirer le joueur")
	if (locale === "es") return /** @type {LocalizedString} */ ("Quitar jugador")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Remover jogador")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi giocatore")
	return /** @type {LocalizedString} */ ("Remove player")
});